<template>
  <div>
    <client-only>
      <FixedHeader
        :threshold="100"
        headerClass="vue-fixed-header vue-fixed-header--isFixed"
        :hideScrollUp="false"
      >
        <nav
          class="navbar py-8 sm:bg-transparent z-10 relative gradient-purple"
        >
          <div
            class="m-auto flex justify-center sm:justify-between hidden-sm-and-down"
            style="width: 90%;"
          >
            <nuxt-link to="/">
              <img
                style="height: 40px"
                alt="logo"
                src="../../assets/AW-logos/logo-3x-h.png"
              />
            </nuxt-link>
            <img
              alt="avc-icon-img"
              class="white"
              style="margin-left: 3rem; 
              border-radius: 6px;"
              src="../../assets/AW-logos/AVCWise-icon.png"
            />
            <div class="flex justify-between m-auto flex-1"></div>
            <div id="wrapper1" class="m-auto">
              <div id="left2">
                <button
                  class="contact-btn index-page btn-yellow text-black py-0 px-0 rounded-full appearance-none"
                  @click="
                    $store.state.user.state.loggedIn
                      ? $router.push('/dashboard/landing')
                      : $router.push('/onboarding/login')
                  "
                >
                  {{
                    $store.state.user.state.loggedIn ? 'My Dashboard' : 'Login'
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="hidden-md-and-up flex ml-4 mr-4">
            <v-row>
              <v-col :md="2" :sm="2" :xs="12" class="my-auto pa-0">
                <nuxt-link to="/">
                  <img
                    style="height: 40px;"
                    alt="logo"
                    src="../../assets/AW-logos/logo@2x.png"
                    class="mx-auto"
                  />
                </nuxt-link>
              </v-col>
              <v-col :md="2" :sm="2" :xs="12">
                <img
                  alt="avc-icon-img"
                  class="white"
                  style="border-radius: 6px;"
                  src="../../assets/AW-logos/AVCWise-icon.png"
                />
              </v-col>
              <v-col />
              <v-col :md="2" :xs="0" :sm="2" class="my-auto text-center pa-0">
                <v-menu
                  offset-y
                  offset-x
                  rounded
                  nudge-left="100%"
                  max-width="100%"
                  max-height="100%"
                  :value="showMenu"
                >
                  <template v-slot:activator="{ on }">
                    <v-app-bar-nav-icon
                      dark
                      v-on="on"
                      :value="showMenu"
                      @click="showMenu = true"
                    ></v-app-bar-nav-icon>
                  </template>
                  <v-list class="black--text">
                    <v-list-item
                      @click="
                        $store.state.user.state.loggedIn
                          ? $router.push('/dashboard/landing')
                          : $router.push('/onboarding/login')
                      "
                    >
                      <v-list-item-content>{{
                        $store.state.user.state.loggedIn
                          ? 'My Dashboard'
                          : 'Login'
                      }}</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </div>
        </nav>
      </FixedHeader>
    </client-only>
    <v-snackbar
      v-model="snackbar.model"
      :color="snackbar.color ? snackbar.color : ''"
      bottom
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>
<script>
import FixedHeader from 'vue-fixed-header';
import { callGAEvent } from '~/plugins/utils.js';
export default {
  components: {
    FixedHeader
  },
  data() {
    return {
      showMenu: false,
      snackbar: {
        model: false,
        text: '',
        color: 'red',
        timeout: 2000
      }
    };
  },
  mounted() {},
  methods: {
    callGAEvent
  }
};
</script>
<style>
.navbar.vue-fixed-header--isFixed {
  z-index: 100;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
}
.nav {
  background-color: #333;
  overflow: hidden;
  color: #000;
  z-index: 0;
}

.nav-btn {
  border-radius: 23.5px;
  border: solid 1px #ffffff;
  color: #ffffff;
}
.contact-btn {
  width: 10rem !important;
}
.text--white {
  color: #ffffff !important;
  text-transform: none !important;
}
.v-tabs-slider {
  background-color: #ffffff;
}
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}

button:focus {
  outline: none !important;
}

.v-card__title {
  word-break: break-word !important;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
